<template>
		<div
		v-show="$store.state.userLimitModal == true"
		role="dialog"
		aria-modal="true"
		class="fade contanctModal centerModal smModal titleContainer modal show"
		tabindex="-1"
		aria-labelledby="contained-modal-title-vcenter"
		style="z-index: 1000000020"
	>
		<div
			v-show="$store.state.userLimitModal == true"
			class="modal-dialog modal-lg modal-dialog-centered"
		>
			<div class="modal-content">
				<button
					@click="$store.state.userLimitModal = false"
					type="button"
					class="closeModalBtnContainer"
				>
					<span class="closeModalBtn" aria-hidden="true"></span
					><span class="sr-only">Close</span>
				</button>
				<div class="modalHeader contanctContainer">
					<div class="modalHeader contanctContainer">
						<h3 class="title">לצפייה בנתונים נוספים</h3>
					</div>
				</div>
				<div class="headerActions formContainer" style="margin-bottom: 20px">
					<button type="button" class="btn blue" @click="login()">
						<svg
							role="img"
							version="1.1"
							id="Layer_1"
							x="0px"
							y="0px"
							viewBox="0 0 24 24"
							enable-background="new 0 0 24 24"
							class="icon mob"
						>
							<path
								fill="#0D3EFB"
								d="M12,6c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S10.3,6,12,6 M12,4C9.2,4,7,6.2,7,9s2.2,5,5,5s5-2.2,5-5  S14.8,4,12,4z"
								class="st0"
							></path>
							<path
								fill="none"
								stroke="#0D3EFB"
								stroke-width="2"
								stroke-miterlimit="10"
								d="M5,20c0-3.9,3.1-7,7-7s7,3.1,7,7"
								class="st1"
							></path>
						</svg>
						<svg
							role="img"
							version="1.1"
							id="Layer_1"
							x="0px"
							y="0px"
							viewBox="0 0 24 24"
							enable-background="new 0 0 24 24"
							class="icon desk"
						>
							<path
								fill="#FFFFFF"
								d="M12,6c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S10.3,6,12,6 M12,4C9.2,4,7,6.2,7,9s2.2,5,5,5s5-2.2,5-5  S14.8,4,12,4z"
								class="st0"
							></path>
							<path
								fill="none"
								stroke="#FFFFFF"
								stroke-width="2"
								stroke-miterlimit="10"
								d="M5,20c0-3.9,3.1-7,7-7s7,3.1,7,7"
								class="st1"
							></path>
						</svg>
						{{ actionText }}
					</button>
				</div>
			</div>
		</div>
	
		</div>


</template>


<script>


export default {
    data() {
        return {

        };
    },
    methods: {
        login() {
			var user = this.currentUser;
			if (user == null){
				this.mixin_goTo(this, "login");
			}
			if (this.currentUser != null && this.currentUser.Verified == false){
				this.mixin_goTo(this, "approve");
			}
        },
    },
	computed:{
		actionText(){
			// get userdata
			//if (user != null && user.hasOwnProperty("userid") == false){
			if (this.currentUser != null && this.currentUser.Verified == false){
				return 'מעבר לאימות חשבון'
			}
			return 'התחברות'
		},
		currentUser() {
			if (this.$store.state.currentUser != null){
				return this.$store.state.currentUser;
			}
			if (this.mixin_getCookie('user') != null){
				var decompessed = this.decompressBase64Gzip(this.mixin_getCookie('user'));
				return decompessed;
			}
			else{
				return null;
			}
		},

	}
};

</script>